// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"466":"bdf5035d","668":"33a7b638","808":"5bbadb81"}[chunkId] + ".chunk.js";
};